<template>
  <div>
    <h2>Review</h2>
    <v-card class="pa-6 my-6 CampD">
      <v-card-title
        class="text-h6 font-weight-bold d-flex justify-space-between align-center"
      >
        <span>Campaign Details</span>
        <div>
          <v-icon
            small
            @click="toggleEdit"
            style="font-size: 23px; margin-right: 1rem"
          >
            {{ isEditing ? "mdi-check" : "mdi-pencil" }}
          </v-icon>
          <v-icon small @click="expanded = !expanded">
            {{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
        </div>
      </v-card-title>

      <v-expand-transition>
        <v-card-text v-show="expanded">
          <v-row dense>
            <v-col cols="12" class="mb-6 d-flex justify-space-between">
              <div class="mt-5">
                <div class="label">Campaign name</div>

                <div v-if="isEditing" class="mt-2">
                  <input
                    v-model="editedCampaignName"
                    @blur="saveCampaignName"
                    @keyup.enter="saveCampaignName"
                    style="
                      padding: 6px 10px;
                      border: 1px solid #ccc;
                      border-radius: 6px;
                      font-size: 14px;
                      width: 250px;
                    "
                    autofocus
                  />
                </div>

                <div v-else class="value">
                  {{ store.campaignData.campaignName }}
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="mb-6">
              <div class="label">Campaign objective</div>
              <div class="value">Video views</div>
            </v-col>

            <v-col cols="12" class="mb-6">
              <div class="label mb-3">Budget</div>
              <div class="d-flex flex-column ga-2 mt-2">
                <div
                  v-for="(platform, index) in store.campaignData.platforms"
                  :key="index"
                  class="d-flex align-center ga-3"
                >
                  <v-avatar size="24">
                    <v-img :src="platform.icon" />
                  </v-avatar>
                  <div class="font-weight-medium" style="min-width: 7rem">
                    {{ platform.name }}
                  </div>
                  <div class="font-weight-bold">${{ platform.amount }}</div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="mb-6">
              <div class="label">Start & End date</div>
              <div class="value">
                {{ store.campaignData.startDate }}-
                {{ store.campaignData.endDate }}
              </div>
            </v-col>

            <v-col cols="12">
              <div class="label">Status</div>
              <div class="value">
                {{ store.campaignData.status ? "Active" : "Inactive" }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import { useSuperAddStore } from "@/store/superAddStore";
export default {
  name: "CampaignDetails",
  data() {
    return {
      expanded: true,
      store: useSuperAddStore(),
      isEditing: false,
      editedCampaignName: "",
    };
  },
  methods: {
    toggleEdit() {
      if (this.isEditing) {
        this.saveCampaignName();
      } else {
        this.editedCampaignName = this.store.campaignData.campaignName;
        this.isEditing = true;
      }
    },
    saveCampaignName() {
      this.store.campaignData.campaignName = this.editedCampaignName.trim();
      this.isEditing = false;
    },
    toggleEdit() {
      console.log("Edit clicked"); // لمتابعة الكونسول
      this.$emit("onEdit", 0);
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
}
.value {
  font-size: 15px;
  color: #222;
}
.CampD {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(102, 102, 102, 0.12);
}
</style>
